import React from 'react';

const SvgSearch = props => (
  <svg data-name="Layer 1" viewBox="0 0 24 24" {...props}>
    <path d="M20.36 19.19L15.15 14a6.54 6.54 0 10-5.22 2.62 6.47 6.47 0 003.93-1.33l5.21 5.22a.91.91 0 001.29-1.29zM9.93 14.77A4.75 4.75 0 1114.66 10a4.74 4.74 0 01-4.73 4.77z" />
  </svg>
);

export default SvgSearch;
